/**
 * Lightweight, best-effort store for the guest's email captured at waitlist
 * signup, so the checkout flow can prefill Stripe's email field.
 *
 * Every access is wrapped in try/catch: storage may be unavailable (private
 * mode, blocked cookies, etc.) and this must never block signup or checkout.
 */
const GUEST_EMAIL_KEY = "cuo_guest_email";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isLikelyEmail(value: string | null | undefined): boolean {
  return typeof value === "string" && EMAIL_RE.test(value.trim());
}

/** Persist the guest email (no-op for blank/invalid values or unavailable storage). */
export function saveGuestEmail(email: string | null | undefined): void {
  const trimmed = typeof email === "string" ? email.trim() : "";
  if (!isLikelyEmail(trimmed)) return;
  try {
    localStorage.setItem(GUEST_EMAIL_KEY, trimmed);
  } catch {
    /* storage unavailable — ignore */
  }
}

/** Read the stored guest email, or "" when missing/invalid/unavailable. */
export function getGuestEmail(): string {
  try {
    const stored = localStorage.getItem(GUEST_EMAIL_KEY)?.trim() ?? "";
    return isLikelyEmail(stored) ? stored : "";
  } catch {
    return "";
  }
}
